import { useQuery } from '@tanstack/react-query'

import { getBlackFriday } from '../../api/marketing/marketing'
import { BlackFridayResponse } from '../../types/marketing/response/BlackFridayResponse'

export const useGetBlackFriday = () => {
  return useQuery<BlackFridayResponse>(
    ['marketing black friday'],
    //@ts-ignore
    async () => getBlackFriday(),
  )
}
